var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('div',{staticClass:"page-wrap"},[_vm._v(" 测试流水线-非静态资源 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }